// Importing Phaser library
import Phaser from 'phaser';

// Importing RexUIPlugin from phaser3-rex-plugins
import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';

// Importing the styles for the game
import './assets/styles/styles.scss';

// Importing the game scenes
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { SlotScene } from './scenes/SlotScene';

// Configuring the game
window.onload = function () {
	const config = {
		type: Phaser.AUTO, // Using the best renderer available
		width: 1920, // The width of the game canvas
		height: 1080, // The height of the game canvas
		scene: [BootScene, PreloadScene, SlotScene], // The game scenes to load
		transparent: true, // Making the background transparent
		physics: {
			default: 'arcade',
			arcade: {
				debug: false,
				gravity: { x: 0, y: 0 }
			}
		},
		scale: {
			mode: Phaser.Scale.FIT // SHOW_ALL, RESIZE, FIT, autoCenter: Phaser.Scale.CENTER_BOTH
		},
		plugins: {
			scene: [
				{
					key: [SlotScene],
					plugin: RexUIPlugin,
					mapping: 'rexUI'
				}
			]
		},
		fx: {
			glow: {
				distance: 2,
				quality: 1
			}
		}
	};
	// Creating a new Phaser game instance with the given configuration
	new Phaser.Game(config);
	window.focus();
};
